import Calendar from './calendar/ca_ES';
import DatePicker from './date-picker/ca_ES';
import Pagination from './pagination/ca_ES';
import TimePicker from './time-picker/ca_ES';

export default {
  locale: 'ca',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtrar Menu',
    filterConfirm: 'OK',
    filterReset: 'Restablir',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'CancelÂ·lar',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'CancelÂ·lar',
  },
  Transfer: {
    searchPlaceholder: 'Cercar aquÃ­',
    itemUnit: 'item',
    itemsUnit: 'items',
  },
  Empty: {
    description: 'Sense dades',
  },
};
